import { useTranslation } from "@ferrivia/i18n";

// Display names for the confirmation dialog, keyed by product *slug* (not
// Stripe lookup key -- lookup keys aren't stable literals in this system, see
// apps/api's catalog tests, which seed them as random strings per
// environment). The dialog only knows the slugs stashed before the Stripe
// redirect. The membership entry outlives the Store tab that sold it in-app:
// a checkout opened before it was removed can still return.
export function useProductNameBySlug(): (slug: string) => string | undefined {
  const { t } = useTranslation("client");

  const names: Record<string, string> = {
    "ferrivia-vuosijasenyys": t("store.products.membership.name", "Ferrivia-jäsenyys"),
    "raudanpuutteen-alkukartoitus": t("store.products.analysis.name", "Raudanpuutteen alkukartoitus"),
    "alkukartoitus-laboratoriopakettiin": t("store.products.analysis.name", "Raudanpuutteen alkukartoitus"),
    "raudanpuutteen-laboratoriopaketti": t("store.products.labPanel.name", "Laboratoriopaketti"),
    "pvk-lisamittaus": t("store.addon.pvk", "Lisää PVK"),
  };

  return (slug: string) => names[slug];
}
